module.exports = __webpack_public_path__ + "img/12_48.9fdf58d5.png";